module.exports = {"630105001":"朝阳街道","630105002":"小桥大街街道","630105003":"马坊街道","630105004":"火车西站","630105100":"大堡子镇","630105101":"廿里铺镇","630105400":"生物科技产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630105.json
// module id = 2982
// module chunks = 0